import { SyncActionFactory } from 'app/shared/utils/redux/sync.actions'

export class LoaderActions {
  public static start = new SyncActionFactory('[LOADER] START')
  public static stop = new SyncActionFactory('[LOADER] STOP')
}
